import { Configuration, BrowserCacheLocation, LogLevel, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

// Azure AD B2C configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: environment.azureAd.clientId, // Reemplazar con tu Client ID de Azure AD
    authority: environment.azureAd.authority, // Reemplazar con tu Tenant ID
    redirectUri: environment.azureAd.redirectUri, // URL de redirección
    postLogoutRedirectUri: environment.azureAd.postLogoutRedirectUri
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Almacenamiento local seguro
    storeAuthStateInCookie: true, // Almacenar estado en cookies para IE11
    secureCookies: false // Cambiar a true en producción con HTTPS
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        console.log(message);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false
    }
  }
};

// Guard configuration
export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: ['user.read']
  },
  loginFailedRoute: '/login-failed'
};

// Interceptor configuration
export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map([
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    ['http://localhost:3000/api/*', ['api://your-api-client-id/access_as_user']] // API backend
  ])
};

// Scopes for different operations
export const loginRequest = {
  scopes: ['openid', 'profile', 'user.read']
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};